import { useState } from 'react';
import {
    Typography, Button, Box, TextField, Popover
} from '@mui/material';

const AuthComponent = ({ token, handleLogin, handleLogout, username, setUsername, password, setPassword, loggedInUser }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);
    const open = Boolean(anchorEl);

    return (
        <Box>
            {!token ? (
                <Button variant="outlined" color="inherit" onClick={handleClick}>Log In</Button>
            ) : (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Typography>Welcome, {loggedInUser}!</Typography>
                    <Button variant="contained" color="secondary" onClick={handleLogout}>Log Out</Button>
                </Box>
            )}
            <Popover open={open} anchorEl={anchorEl} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} transformOrigin={{ vertical: 'top', horizontal: 'right' }}>
                <Box sx={{ p: 2, width: 250 }}>
                    <Typography variant="h6" component="h3" gutterBottom>Login</Typography>
                    <form onSubmit={(e) => { handleLogin(e); handleClose(); }}>
                        <TextField label="Username" variant="outlined" size="small" fullWidth value={username} onChange={(e) => setUsername(e.target.value)} required sx={{ mb: 2 }} />
                        <TextField label="Password" type="password" variant="outlined" size="small" fullWidth value={password} onChange={(e) => setPassword(e.target.value)} required sx={{ mb: 2 }} />
                        <Button type="submit" variant="contained" fullWidth>Submit</Button>
                    </form>
                </Box>
            </Popover>
        </Box>
    );
};
export default AuthComponent;